export enum INVITATION_TYPE {
  SPACE_TOKEN_USER_INVITATION = "SPACE_TOKEN_USER_INVITATION",
  TARGET_USER_INVITATION = "TARGET_USER_INVITATION",
  TARGET_GUEST_INVITATION = "TARGET_GUEST_INVITATION",
}

export enum TYPE_INVITATION {
  NONE,
  USER,
  GUEST,
  EDUCATION,
}
